import { render } from "./PayNowQRCodeGenerator.vue?vue&type=template&id=215ce7f2&scoped=true"
import script from "./PayNowQRCodeGenerator.vue?vue&type=script&lang=js"
export * from "./PayNowQRCodeGenerator.vue?vue&type=script&lang=js"

import "./PayNowQRCodeGenerator.vue?vue&type=style&index=0&id=215ce7f2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215ce7f2"]])

export default __exports__